exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dual-selects[data-v-738e25d7]{font-family:Avenir,Helvetica,Arial,sans-serif;margin-top:60px;display:grid;grid-template-columns:30% 10% 30%;align-items:center;justify-content:space-between;padding-left:30px;padding-right:30px}.dual-selects h2[data-v-738e25d7]{font-size:1.25rem}.dual-selects select[data-v-738e25d7]{height:200px;width:100%}.dual-selects .middle[data-v-738e25d7]{text-align:center}.dual-selects button[data-v-738e25d7]{width:80%;margin-bottom:5px}", ""]);

// exports
